<template>
	<vxe-modal v-model="val1" width="1000" height="1000" show-footer>
		<template #title>
			<span style="color:red">测试专用</span>
		</template>
		<template #corner>
			<vxe-icon name="bell-fill"></vxe-icon>
			<vxe-icon name="minus"></vxe-icon>
		</template>
		<template #default>
			<div class="full flex" style="flex-direction: column;">
				<div class="zhang">
					<el-button @click="readWordFile">上传</el-button>
					<!-- <el-button @click="audit">盖章</el-button> -->
					<el-button @click="downloadPDF">下载PDF</el-button>
				</div>
				<div id="editable" contenteditable="true" style="border: 1px solid #ccc; padding: 10px;">
					点击这里并按下 Ctrl+V 来粘贴内容
				</div>
				<div ref="wordarticle" style="overflow: auto;flex: 1;">
					<div class="preload_box zhang" id="preload_box"></div>
				</div>
			</div>
		</template>
	</vxe-modal>
</template>
<style>

</style>

<script>
	import {
		renderAsync
	} from 'docx-preview'
	import {
		jsPDF
	} from "jspdf";
	import html2canvas from 'html2canvas';
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				val1: true,
				htmlContent: ''
			}
		},
		watch: {

		},
		mounted() {
this.$nextTick(()=>{
	const editable = document.getElementById('editable');
	
	// 监听粘贴事件
	editable.addEventListener('paste', function(event) {
		// 阻止默认粘贴行为
		event.preventDefault();
	
		// 获取粘贴板的内容
		const clipboardData = (event.clipboardData || window.clipboardData);
		const pastedData = clipboardData.getData('text/plain');
	
		// 输出粘贴板的内容
		console.log('粘贴板内容:', pastedData);
	
		// 如果需要，将内容粘贴到可编辑的元素中
		// editable.innerText = pastedData;
	});
})
		},
		computed: {

		},

		methods: {
			//http://47.98.231.105/api/public/storage/company/20230731/fb59897377b510c9e1c55c813769808a.png
			previewDOCX(file) {
				let reader = new FileReader()
				reader.readAsArrayBuffer(file, file.name, {
					type: 'blob'
				})
				reader.onload = (e) => {
					let data = e.target.result
					renderAsync(data, document.getElementById("preload_box"), null, {
						className: "docx", // 默认和文档样式类的类名/前缀
						inWrapper: true, // 启用围绕文档内容渲染包装器
						ignoreWidth: false, // 禁止页面渲染宽度
						ignoreHeight: false, // 禁止页面渲染高度
						ignoreFonts: false, // 禁止字体渲染
						breakPages: true, // 在分页符上启用分页
						ignoreLastRenderedPageBreak: true, //禁用lastRenderedPageBreak元素的分页
						experimental: false, //启用实验性功能（制表符停止计算）
						trimXmlDeclaration: true, //如果为真，xml声明将在解析之前从xml文档中删除
						debug: false, // 启用额外的日志记录
					}).then(() => {
						var targetTag = document.getElementsByTagName('article');
						let that = this
						function findElementWithText(node) {
							if (node.nodeType === 1 && node.textContent.includes('盖章区')) { // 检查节点类型是否为元素节点
								if (node.innerHTML == '盖章区') {
									var button = document.createElement("button")
									button.innerHTML = '盖章'
									node.innerHTML = "";
									node.addEventListener('click', function() {
										that.audit()
									});
									node.appendChild(button);
								}

							}
							for (var i = 0; i < node.childNodes.length; i++) {
								findElementWithText(node.childNodes[i]);
							}
						}
						findElementWithText(targetTag[0]);
					})


				}
			},
			readWordFile() {
				const fileInput = document.createElement('input');
				fileInput.type = 'file';
				fileInput.accept = '.docx';

				fileInput.addEventListener('change', (event) => {
					const file = event.target.files[0];
					if (file) {
						this.previewDOCX(file)
					}
				});

				fileInput.click();
			},
			audit() {
				let that = this
				var targetTag = document.getElementsByTagName('article');

				function findElementWithText(node) {
					if (node.nodeType === 1 && node.textContent.includes('盖章')) { // 检查节点类型是否为元素节点
						if (node.innerHTML == '盖章') {
							// console.log(node)
							const wordarticle = that.$refs.wordarticle
							wordarticle.scrollTop = wordarticle.scrollHeight
							var imgNode = document.createElement("img");
							imgNode.classList.add("zhang")
							imgNode.src =
								"http://47.98.231.105/api/public/storage/company/20230731/fb59897377b510c9e1c55c813769808a.png"; // 用你的图片 URL 替换这里
							imgNode.style = "width:100px;margin-top:-50px;margin-left:-20px;"

							node.parentNode.replaceChild(imgNode, node);
						}

					}
					for (var i = 0; i < node.childNodes.length; i++) {
						findElementWithText(node.childNodes[i]);
					}
				}
				findElementWithText(targetTag[0]);
			},
			downloadPDF() {
				this.loading = true
				let scale = 2
				html2canvas(document.getElementsByClassName('docx')[0], {
					scale: scale,
				}).then((canvas) => {
					let timeStamp = new Date().getTime()
					let date = window.systemMethods.timestampToDate(timeStamp, true)
					let title = "合同" + date
					let contentWidth = canvas.width / scale
					let contentHeight = canvas.height / scale
					let PDF = new jsPDF('p', 'pt', [contentWidth, contentHeight])
					let pdfWidth = PDF.internal.pageSize.getWidth()
					let pdfHeight = contentHeight / contentWidth * pdfWidth
					let pageData = canvas.toDataURL('image/jpeg', 1.0)
					PDF.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
					PDF.save(title + '.pdf')
					this.loading = false
				})
			},
			// convertToHtml(wordData) {
			// 	mammoth.extractRawText({
			// 			arrayBuffer: wordData
			// 		})
			// 		.then(result => {
			// 			// result.value contains the plain text content
			// 			this.htmlContent = result.value;
			// 		})
			// 		.catch(error => {
			// 			console.error(error);
			// 		});
			// }
		},
		components: {

		}
	}
</script>
